import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";

import { getImage } from "@faire/retailer/features/MarketplaceItems/ProductDetailsTile/getImage";

export interface SearchProductImageProps {
  productToken: string | undefined;
  productName: string | undefined;
  image: IImage;
  productSearchString: string;
  spellCorrectedQuery: string | undefined;
}

export const searchProductImagePropsILeanProductTileAdapter = (
  productTile: ILeanProductTile,
  productSearchString: string,
  spellCorrectedQuery: string | undefined
): SearchProductImageProps => {
  return {
    productToken: productTile.product?.token,
    productName: productTile.product?.name,
    image: getImage(productTile),
    productSearchString,
    spellCorrectedQuery,
  };
};
